module.exports = __webpack_public_path__ + "static/media/9.9067b5c2.jpg";